import type { ComponentType } from "react";
import { SvgIconProps } from "@mui/material";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ImageIcon from "@mui/icons-material/Image";
import TableChartIcon from "@mui/icons-material/TableChart";
import DescriptionIcon from "@mui/icons-material/Description";
import SlideshowIcon from "@mui/icons-material/Slideshow";
import FolderZipIcon from "@mui/icons-material/FolderZip";
import ArticleIcon from "@mui/icons-material/Article";

// eslint-disable-next-line import/prefer-default-export
export const getFileIconComponent = (
  contentType: string | undefined,
): ComponentType<SvgIconProps> => {
  const type = (contentType ?? "").toLowerCase();

  if (type.includes("pdf")) return PictureAsPdfIcon;
  if (type.startsWith("image/")) return ImageIcon;
  if (
    type.includes("spreadsheet") ||
    type.includes("excel") ||
    type.includes("csv")
  )
    return TableChartIcon;
  if (type.includes("wordprocessingml") || type.includes("msword"))
    return DescriptionIcon;
  if (type.includes("presentation") || type.includes("powerpoint"))
    return SlideshowIcon;
  if (type.includes("zip") || type.includes("compressed")) return FolderZipIcon;
  if (type.startsWith("text/")) return ArticleIcon;

  return InsertDriveFileIcon;
};
